// Getter / Selecteur => Cest ici quon ferait des modifs aux valeurs avant de les "gets" dans les vues.
// ex
export const value = (state: any) => {
  return state.value;
};
